<header> </header>
<!-- begin main content -->
<div class="container" role="main" id="main-content">
    <div class="row">
        <div class="col-md-12 acl-container">
            <!-- left navigation -->
            <sideNav></sideNav>
            <!-- .end left navigation -->
            <div class="col-md-9">
                <h2 *ngIf="pageName != 'Support Groups'">{{section}} - {{pageName}} - Total People Served, Service Units, and Expenditures</h2>
                <h2 *ngIf="pageName == 'Support Groups'">{{section}} - {{pageName}} - Service Units, Expenditures and Program Income</h2>
                <p class="info mt-1">All fields are required</p>
                <div class="col-md-12 background-gray-lighter mb-1">
                  <h2><span *ngIf="pageName != 'Support Groups'">Total Served and </span>Service Units</h2>
                </div>
                <div *ngIf="pageName != 'Support Groups'" class="col-md-8">
                    <label *ngIf="!supportOrInfoPage()" for="totalPersonsServed" class="normal">Total unduplicated persons served</label>
                    <label *ngIf="supportOrInfoPage()" for="totalPersonsServed" class="normal">Total estimated persons served</label>
                </div>
                <div *ngIf="pageName != 'Support Groups'"  class="col-md-4 mb-1">
                    <div [ngClass]="calculateOutlineColor(_sectionModel.totalPersonsServed.questionStatus)">
                        <div *ngIf="!supportOrInfoPage()" class="input-group">
                            <input [(ngModel)]="_sectionModel.totalPersonsServed.elementValue" [disabled]="!_sectionModel.totalPersonsServed.isRequired"
                                type="text" class="form-control" id="totalPersonsServed" (change)="unsavedChanges = true; _sectionModel.totalPersonsServed.elementValue = addComma(_sectionModel.totalPersonsServed.elementValue); _sectionModel.totalPersonsServed = validate(_sectionModel.totalPersonsServed); checkValidForm(); updateTotals();">
                            <div class="input-group-addon">Persons</div>
                        </div>
                        <div *ngIf="supportOrInfoPage()">
                            <input [(ngModel)]="_sectionModel.totalPersonsServed.elementValue" [disabled]="!_sectionModel.totalPersonsServed.isRequired"
                                type="text" class="form-control" id="totalPersonsServed" (change)="unsavedChanges = true; _sectionModel.totalPersonsServed.elementValue = addComma(_sectionModel.totalPersonsServed.elementValue); _sectionModel.totalPersonsServed = validate(_sectionModel.totalPersonsServed); checkValidForm(); updateTotals();">
                        </div>
                    </div>
                    <div *ngIf="!!_sectionModel.totalPersonsServed.dataEntryErrorMessage" class="alert alert-danger" role="alert">
                        <i class="fa fa-times" aria-hidden="true"></i>
                        <span class="sr-only">Error:</span>&nbsp;{{_sectionModel.totalPersonsServed.dataEntryErrorMessage}}
                    </div>
                    <div *ngIf="!_sectionModel.totalPersonsServed.dataEntryErrorMessage && (_sectionModel.totalPersonsServed.questionStatus == questionStatusEnum.L2InProgressError || _sectionModel.totalPersonsServed.questionStatus == questionStatusEnum.L2ValidatedWarning)"
                        [ngClass]="setErrorDisplayType(_sectionModel.totalPersonsServed.questionStatus)" role="alert">
                        <i *ngIf="_sectionModel.totalPersonsServed.questionStatus == questionStatusEnum.L2ValidatedWarning" class="fa fa-exclamation-triangle"
                            aria-hidden="true"></i>
                        <span class="sr-only">Warning:</span>
                        <i *ngIf="_sectionModel.totalPersonsServed.questionStatus != questionStatusEnum.L2ValidatedWarning" class="fa fa-times" aria-hidden="true"></i>
                        <span class="sr-only">Error:</span>
                        &nbsp;{{_sectionModel.totalPersonsServed.businessErrorMessage}}
                    </div>
                </div>
                <div class="col-md-8">
                    <label for="inputtotalServiceUnits" class="normal">Total service units</label>
                </div>
                <div class="col-md-4 mb-1">
                    <acl-data-element-text [id]="'inputtotalServiceUnits'" [de]="_sectionModel.totalServiceUnits"
                    [addOnOptions]="(pageName.includes('Case') || pageName.includes('Training') || pageName.includes('Counsel')) ? createAddOnOptions('Hours', addOnWidth) :
                    pageName.includes('Assistance') ? createAddOnOptions('Contacts', addOnWidth) : pageName.includes('Supp') ? createAddOnOptions('Sessions', addOnWidth) :
                    createAddOnOptions('Activities', addOnWidth)"
                    (change)="updateTotals(); onChange()">
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.totalServiceUnits"></acl-input-error>
                </div>

                <div class="col-md-12 background-gray-lighter mb-1">
                    <h2>Expenditures</h2>
                </div>
                <div class="col-md-9">
                  <label for="inputexpend" class="normal">Title III expenditure</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [id]="'inputexpend'" [de]="_sectionModel.expend"
                    [addOnOptions]="addOnOption"
                    (change)="updateTotals(); onChange()">
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.expend"></acl-input-error>
                </div>
                <div class="col-md-9">
                    <label for="inputexpendOtherState" class="normal">Other: State expenditure</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [id]="'inputexpendOtherState'" [de]="_sectionModel.expendOtherState"
                    [addOnOptions]="addOnOption"
                    (change)="updateTotals(); onChange()">
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.expendOtherState"></acl-input-error>
                </div>
                <div class="col-md-9">
                    <label for="inputexpendOtherNonState" class="normal">Other: Non-state expenditure</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [id]="'inputexpendOtherNonState'" [de]="_sectionModel.expendOtherNonState"
                    [addOnOptions]="addOnOption"
                    (change)="updateTotals(); onChange()">
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.expendOtherNonState"></acl-input-error>
                </div>
                <div class="col-md-9">
                    <label for="inputprogramIncome" class="normal">Program income expended</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [id]="'inputprogramIncome'" [de]="_sectionModel.programIncome"
                    [addOnOptions]="addOnOption"
                    (change)="updateTotals(); onChange()">
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.programIncome"></acl-input-error>
                </div>
                <div class="col-md-9">
                    <label for="inputexpendTotal" class="normal">Total expenditures</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [id]="'inputexpendTotal'" [de]="_sectionModel.expendTotal"
                    [addOnOptions]="addOnOption" [disabled]=true>
                    </acl-data-element-text>
                    <acl-input-error [de]="_sectionModel.expendTotal"></acl-input-error>
                </div>
                <div class="col-md-9">
                    <label for="inputtotalExpendPerUnit" class="normal">Total expenditure per unit</label>
                </div>
                <div class="col-md-3 mb-1">
                    <acl-data-element-text [id]="'inputtotalExpendPerUnit'" [de]="_sectionModel.totalExpendPerUnit"
                    [addOnOptions]="addOnOption" [disabled]=true>
                    </acl-data-element-text>
                </div>

                <div class="col-md-12 row">
                    <div *ngIf="!validForm" class="has-error">
                        <p class="help-block">There are errors on the page. You must fix the errors or clear the data in those fields in order
                            to Save this form.</p>
                    </div>
                    <button *ngIf="!validForm" data-target="#nextModal" data-toggle="modal" class="btn btn-primary mr-1">Next</button>
                    <button *ngIf="validForm" class="btn btn-primary mr-1" (click)="saveAndNext()">Save and next</button>
                    <button class="btn btn-default mr-1" (click)="save()" [disabled]="!validForm || !_sectionModel.isRequired">Save</button>
                    <a class="btn btn-link pull-right" [routerLink]="['/data-submissions/titleIIIOverview']">Return to Overview</a>
                </div>
                <div aria-labelledby="nextModalLabel" class="modal fade" id="nextModal" role="dialog" tabindex="-1" style="display: none;">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                    <span aria-hidden="true">×</span>
                                </button>
                                <h3 class="modal-title" id="nextModalLabel">Recent changes on this page will not be saved</h3>
                            </div>
                            <div class="modal-body">
                                <p>
                                    There are errors on the page. You must fix the errors or clear the data in those fields in order to save this form.
                                    <br />
                                    <br /> You may select "Go back to form" to remove the errors or you may select "Proceed to
                                    next section" and all of new the data entered in the current section will be lost.
                                </p>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-primary pull-left" data-dismiss="modal" type="button" href="#">Go back to form</button>
                                <button class="btn btn-primary pull-right" data-dismiss="modal" type="button" (click)="next()">Proceed to next section</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <!-- .end col-md-9 -->
        </div>
        <!-- .end acl-container (col-md-12) -->
    </div>
    <!-- .end row -->
</div>
<!-- ./container -->
